import api from '@/api/api';
import { createQueryParams } from '@/utils/createQueryParams';

const DOMAIN = '/session-whatsapp';

const get = async (
	params: SessionWhatsApp.ListParams,
): Promise<SessionWhatsApp.ListResponse> => {
	const queryParams = createQueryParams({ ...params });
	const { data } = await api.get(`${DOMAIN}?${queryParams}`);
	return data;
};

const getById = async (
	id: string,
): Promise<SessionWhatsApp.SessionWhatsAppNotification> => {
	const { data } = await api.get(`${DOMAIN}/${id}`);
	return data;
};

const create = async (
	body: SessionWhatsApp.CreateBody,
): Promise<SessionWhatsApp.SessionWhatsAppNotification> => {
	const { data } = await api.post(DOMAIN, body);
	return data;
};

const patch = async (
	id: string,
	body: SessionWhatsApp.UpdateBody,
): Promise<SessionWhatsApp.SessionWhatsAppNotification> => {
	const { data } = await api.patch(`${DOMAIN}/${id}`, body);
	return data;
};

const remove = async (id: string): Promise<void> => {
	await api.delete(`${DOMAIN}/${id}`);
};

const SessionWhatsAppService = {
	get,
	getById,
	create,
	patch,
	remove,
};

export { SessionWhatsAppService };
